
















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import WorkshopsBookingDetails from "../workshops/WorkshopsBookingDetails.vue";

import { WorkshopBookingStatus } from "../../shared/WorkshopBookingStatus";
import WorkshopJson from "../../shared/WorkshopJson";
import WorkshopBookingJson from "../../shared/WorkshopBookingJson";
import { WorkshopWithBookingsJson } from "../../shared/WorkshopJson";
import { WorkshopWithBookingJson } from "../../shared/WorkshopJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "WorkshopsOverview",
  components: {
    Loading,
    TableView,
    WorkshopsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    WorkshopsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      attentionalWorkshopBookings: null as WorkshopWithBookingJson[] | null,
      attentionalWorkshopBookingsMoreAvailable: null as boolean | null,
      selectedWorkshopId: null as number | null,

      selectedWorkshopBookingId: null as number | null,
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: WorkshopWithBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedWorkshopId = item.ID;
        this.selectedWorkshopBookingId = item.booking.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },

    loadData() {
      this.loadAttentionalWorkshopBookings();
    },

    async loadAttentionalWorkshopBookings(loadMore: null = null) {
      var states = [WorkshopBookingStatus.requested];
      var afterDateTime = null;

      //load more
      if (loadMore && this.attentionalWorkshopBookings != null) {
        this.attentionalWorkshopBookingsMoreAvailable = null;

        let lastBooking = this.attentionalWorkshopBookings[this.attentionalWorkshopBookings.length - 1].booking;

        afterDateTime = new Date(lastBooking.bookingDateTime);
      } else {
        this.attentionalWorkshopBookings = null;
      }

      //final load workshops
      if (this.restClient != null) {
        try {
          let bookings = await this.restClient.getAggregatedWorkshopBookings(states, afterDateTime);

          if (loadMore && this.attentionalWorkshopBookings != null) {
            this.attentionalWorkshopBookings = this.attentionalWorkshopBookings.concat(bookings.workshopBookings);
          } else {
            this.attentionalWorkshopBookings = bookings.workshopBookings;
          }

          this.attentionalWorkshopBookingsMoreAvailable = bookings.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadData();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    workshopColumns: function (): TableViewColumnDefinitions<WorkshopWithBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Kurs",
          td: (i) => i.title,
        },
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.booking.customer.guardianLastName != ""
              ? i.booking.customer.guardianLastName + ", " + i.booking.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Teilnehmende:r)",
          td: (i) =>
            i.booking.customer.childLastName != ""
              ? i.booking.customer.childLastName + ", " + i.booking.customer.childFirstName
              : "--",
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.booking.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.WorkshopsBookingStatusNames[i.booking.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<WorkshopWithBookingJson>[];
    },
  },
});
